import { config } from "core/config/app";
import MenuPage from "./pages/MenuPage";
import ChangePassword from "./pages/ChangePassword";
import ConfirmPassword from "./pages/ConfirmPassword";
import LanguageSetting from "./pages/LanguageSetting";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LeaveMembership from "./pages/LeaveMembership";
import ChangeDisplayName from "./pages/ChangeDisplayName";
import NotificationList from "./pages/NotificationList";
import NotificationSetting from "./pages/NotificationSetting";

const router = [
  {
    name: "MENU",
    // auth: false,
    exact: false,
    path: `${config?.basename}/menu`,
    element: <MenuPage />,
    title: "Menu",
  },
  {
    name: "CONFIRM_PASSWORD",
    auth: true,
    exact: true,
    path: `${config?.basename}/menu/confirm-password`,
    element: <ConfirmPassword />,
    title: "Confirm Password",
  },
  {
    name: "CHANGE_PASSWORD",
    auth: true,
    exact: true,
    path: `${config?.basename}/menu/change-password`,
    element: <ChangePassword />,
    title: "Change Password ",
  },
  {
    name: "LANGUAGE_SETTING",
    // auth: true,
    exact: true,
    path: `${config?.basename}/menu/language-setting`,
    element: <LanguageSetting />,
    title: "Language Setting",
  },
  {
    name: "PRIVACY_POLICY_APP",
    // auth: true,
    exact: true,
    path: `${config?.basename}/menu/privacy-policy-app`,
    element: <PrivacyPolicy />,
    title: "Privacy Policy",
  },
  {
    name: "LEAVE_MEMBERSHIP",
    auth: true,
    exact: true,
    path: `${config?.basename}/menu/leave-membership`,
    element: <LeaveMembership />,
    title: "Leave Membership ",
  },
  {
    name: "CHANGE_DISPLAY_NAME",
    auth: true,
    exact: true,
    path: `${config?.basename}/menu/change-display-name`,
    element: <ChangeDisplayName />,
    title: "Change Display Name ",
  },
  {
    name: "NOTIFICATION_LIST",
    auth: true,
    exact: true,
    path: `${config?.basename}/notifications`,
    element: <NotificationList />,
    title: "Notification List",
  },
  {
    name: "NOTIFICATION_SETTING",
    auth: true,
    exact: true,
    path: `${config?.basename}/notification-setting`,
    element: <NotificationSetting />,
    title: "Notification Setting",
  },
];
export default router;
